import { render, staticRenderFns } from "./cardFaqDelete.vue?vue&type=template&id=03bcc792"
import script from "./cardFaqDelete.vue?vue&type=script&lang=js"
export * from "./cardFaqDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports